export default "__VITE_ASSET__DxXKmM0p__";